import type { FitPassport } from '@/types/passport';

const PASSPORT_KEY = 'fitmap:passport';

export function getPassport(): FitPassport | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(PASSPORT_KEY);
    return raw ? (JSON.parse(raw) as FitPassport) : null;
  } catch {
    return null;
  }
}

export function savePassport(passport: FitPassport): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(PASSPORT_KEY, JSON.stringify(passport));
  } catch {
    // Storage unavailable — the in-memory copy in useFitPassport still works for this session.
  }
}

export function deletePassport(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(PASSPORT_KEY);
  } catch {
    // Nothing to do if storage is unavailable — there's nothing persisted to remove.
  }
}
